// The backend already turns VIO's relative /uploads/... paths into absolute
// URLs, so no VIO address is needed (or baked) in this bundle.

function getBase64ImageMime(value) {
  const s = String(value || "").trim();
  if (s.startsWith("/9j/")) return "image/jpeg";
  if (s.startsWith("iVBORw0KGgo")) return "image/png";
  if (s.startsWith("R0lGOD")) return "image/gif";
  if (s.startsWith("UklGR")) return "image/webp";
  if (s.startsWith("PHN2Zy")) return "image/svg+xml";
  return "";
}

export function resolveVioAssetUrl(raw) {
  if (raw == null) return null;
  const s = typeof raw === "string" ? raw.trim() : "";
  if (!s) return null;
  if (/^(https?:|data:image\/|blob:)/i.test(s)) return s;

  const mime = getBase64ImageMime(s);
  if (mime) return `data:${mime};base64,${s}`;

  return s;
}

export function resolveRewardImageUrl(reward) {
  if (!reward) return null;
  return resolveVioAssetUrl(
    reward.voucherImage ||
      reward.tokenIcon ||
      reward.imageUrl ||
      reward.image?.imageUrl ||
      null
  );
}
